(function () {
  'use strict';

  const STORAGE_KEY = 'auraya_designer_scroll_position';

  console.log('Auraya Designer Scroll Fix Loaded');


  /*
   * Find the Designer filter specifically.
   *
   * FIX #1: the heading text becomes "Designers1" / "Designers 1"
   * once a designer is selected (Liquid adds a count badge span
   * inside the <h3>). The old exact-match `title !== 'designers'`
   * check then fails forever after the first selection, so the
   * scroll container is never found again and restore silently
   * does nothing. Using startsWith on a whitespace-collapsed,
   * digit-stripped string fixes it for any count.
   *
   * FIX #2: previously this picked the UL if it happened to be
   * "scrollable enough", otherwise fell back to the wrapping DIV.
   * On some collections the wrong one got picked (both elements
   * carry the same "custom-scrollbar" class in your markup), so
   * scrollTop got read/written on an element that never actually
   * moves — meaning we were "saving" 0 every time. Now we check
   * BOTH the UL and the DIV and use whichever one genuinely
   * overflows (scrollHeight - clientHeight is largest), which is
   * the one the browser is actually scrolling.
   */
  function getDesignerScrollContainer() {
    const headings = document.querySelectorAll('h3');

    for (const heading of headings) {
      const title = heading.textContent
        .replace(/[0-9]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      if (!title.startsWith('designer')) continue;

      const content = heading.nextElementSibling;

      if (!content) continue;

      const ul = content.querySelector('ul.items.custom-scrollbar');

      const candidates = ul ? [ul, content] : [content];

      let best = null;
      let bestOverflow = 0;

      candidates.forEach(function (el) {
        const overflow = el.scrollHeight - el.clientHeight;
        if (overflow > bestOverflow) {
          bestOverflow = overflow;
          best = el;
        }
      });

      return best || ul || content;
    }

    return null;
  }


  /*
   * Save scroll position
   */
  function saveDesignerScroll() {
    const container = getDesignerScrollContainer();

    if (!container) {
      console.log('Designer container not found');
      return;
    }

    const scrollTop = container.scrollTop;

    sessionStorage.setItem(
      STORAGE_KEY,
      String(scrollTop)
    );

    console.log(
      'Designer scroll SAVED:',
      scrollTop
    );
  }


  /*
   * Get saved position
   */
  function getSavedScrollPosition() {
    const saved = sessionStorage.getItem(STORAGE_KEY);

    if (saved === null) {
      return null;
    }

    const scrollTop = Number(saved);

    if (Number.isNaN(scrollTop)) {
      return null;
    }

    return scrollTop;
  }


  /*
   * Only restore scroll when the Designers filter is actually
   * active. On a fresh/unfiltered page load (or after "Clear
   * all"), we want the normal top-of-page behavior instead.
   *
   * FIX: don't parse the URL for a specific param name
   * (filter.p.vendor=...) — different collections can use a
   * different underlying filter (vendor field vs tag vs
   * metafield), so the param name isn't the same everywhere and
   * the URL check silently failed on those collections. Instead,
   * read the actual state Liquid already renders: the small
   * count badge next to "Designers" that appears whenever
   * filter.active_values.size > 0, whatever the param is called.
   */
  function isDesignerFilterActive() {
    const headings = document.querySelectorAll('h3');

    for (const heading of headings) {
      const title = heading.textContent
        .replace(/[0-9]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      if (!title.startsWith('designer')) continue;

      const content = heading.nextElementSibling;

      if (!content) {
        console.log('[DEBUG] Designers heading found but no content sibling — treating as inactive.');
        return false;
      }

      // A selected designer's <li> gets the "current-filter" class
      // from Liquid (see value.active in collection-sidebar.liquid).
      // This is the actual selection state, unlike the badge count
      // which apparently isn't rendered inside this <h3> on this
      // theme/page.
      const activeItem = content.querySelector('.current-filter');
      const active = !!activeItem;

      console.log('[DEBUG] Designers content has .current-filter item:', active);

      return active;
    }

    console.log('[DEBUG] No <h3> starting with "designer" found on this page at all.');
    return false;
  }


  /*
   * Restore scroll position
   */
  function restoreDesignerScroll() {
    if (!isDesignerFilterActive()) {
      // FIX: do NOT clear sessionStorage here. During an AJAX
      // filter swap the sidebar can briefly render with no
      // "current-filter" class (loading state / DOM mid-replace),
      // so this branch used to fire and wipe out a value we'd
      // just saved moments earlier — before the real filtered
      // content even finished rendering. Just skip restoring for
      // this particular check; the value stays intact for the
      // next retry (or for "Clear all", which clears it
      // explicitly below).
      console.log('[DEBUG] restore skipped: no active Designers filter detected right now (value kept for next retry).');
      return;
    }

    const scrollTop = getSavedScrollPosition();

    console.log('[DEBUG] raw sessionStorage value:', sessionStorage.getItem(STORAGE_KEY), '-> parsed:', scrollTop);

    if (scrollTop === null) {
      console.log('[DEBUG] restore skipped: nothing saved in sessionStorage.');
      return;
    }

    const container = getDesignerScrollContainer();

    if (!container) {
      console.log('[DEBUG] restore skipped: getDesignerScrollContainer() returned null.');
      return;
    }

    console.log('[DEBUG] container found, current scrollTop before restore:', container.scrollTop, 'scrollHeight:', container.scrollHeight, 'clientHeight:', container.clientHeight);

    container.scrollTop = scrollTop;

    console.log(
      'Designer scroll RESTORED:',
      scrollTop
    );
  }


  /*
   * Restore multiple times because Shopify
   * replaces the filter HTML through AJAX.
   */
  function restoreMultipleTimes() {
    restoreDesignerScroll();

    requestAnimationFrame(function () {
      restoreDesignerScroll();
    });

    setTimeout(function () {
      restoreDesignerScroll();
    }, 50);

    setTimeout(function () {
      restoreDesignerScroll();
    }, 150);

    setTimeout(function () {
      restoreDesignerScroll();
    }, 300);

    setTimeout(function () {
      restoreDesignerScroll();
    }, 500);

    setTimeout(function () {
      restoreDesignerScroll();
    }, 800);

    setTimeout(function () {
      restoreDesignerScroll();
    }, 1200);

    setTimeout(function () {
      restoreDesignerScroll();
    }, 2000);
  }


  /*
   * IMPORTANT:
   * Save BEFORE Shopify changes the filter.
   *
   * pointerdown happens before click/change.
   */
  document.addEventListener(
    'pointerdown',
    function (event) {

      const container = getDesignerScrollContainer();

      if (!container) {
        return;
      }

      /*
       * Only save if the clicked element
       * is inside Designer filter.
       */
      if (container.contains(event.target)) {

        console.log(
          'Designer checkbox/label clicked'
        );

        saveDesignerScroll();
      }
    },
    true
  );


  /*
   * Touch devices
   */
  document.addEventListener(
    'touchstart',
    function (event) {

      const container = getDesignerScrollContainer();

      if (!container) {
        return;
      }

      if (container.contains(event.target)) {
        saveDesignerScroll();
      }
    },
    true
  );


  /*
   * FIX #3: continuous scroll tracking, as a safety net on top of
   * the pointerdown/touchstart save. If the click-timing save ever
   * misses (wrong element detected at that exact instant, event
   * order differences across browsers, etc.), this keeps the saved
   * position in sync with wherever the user actually scrolled to.
   * 'scroll' doesn't bubble, so this listens in the capture phase
   * on document, which does see it. Lightly throttled so it isn't
   * running the full heading search on every scroll tick.
   */
  let scrollSaveThrottle = null;

  document.addEventListener(
    'scroll',
    function (event) {
      const container = getDesignerScrollContainer();

      if (!container || event.target !== container) {
        return;
      }

      if (scrollSaveThrottle) return;

      scrollSaveThrottle = setTimeout(function () {
        scrollSaveThrottle = null;
      }, 150);

      saveDesignerScroll();
    },
    true
  );


  /*
   * Explicitly clear the saved position when the user hits
   * "Clear all" (facet-clear-all) — this is the one place we
   * deliberately want to forget it, since after this the
   * Designers list should behave normally (no restore, top of
   * list) on whatever page loads next.
   */
  document.addEventListener(
    'pointerdown',
    function (event) {
      const clearAllEl = event.target.closest(
        'facet-clear-all, .facet-clear-all'
      );

      if (clearAllEl) {
        sessionStorage.removeItem(STORAGE_KEY);
        console.log('[DEBUG] "Clear all" clicked — saved scroll position cleared.');
      }
    },
    true
  );


  /*
   * Shopify AJAX / DOM replacement detection
   */
  const observer = new MutationObserver(function () {

    const savedPosition =
      getSavedScrollPosition();

    if (savedPosition === null) {
      return;
    }

    restoreMultipleTimes();

  });


  observer.observe(document.body, {
    childList: true,
    subtree: true
  });


  /*
   * Shopify section events
   */
  document.addEventListener(
    'shopify:section:load',
    function () {
      restoreMultipleTimes();
    }
  );


  document.addEventListener(
    'shopify:section:reorder',
    function () {
      restoreMultipleTimes();
    }
  );


  document.addEventListener(
    'shopify:section:select',
    function () {
      restoreMultipleTimes();
    }
  );


  /*
   * Initial page load
   * (FIX: use restoreMultipleTimes here too, not a single call —
   * on a full navigation the sidebar's layout/fonts may settle
   * slightly after DOMContentLoaded, so one immediate attempt can
   * run before scrollHeight is accurate.)
   */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        restoreMultipleTimes();
      }
    );

  } else {

    restoreMultipleTimes();

  }


  /*
   * Browser back / forward
   */
  window.addEventListener(
    'pageshow',
    function () {
      restoreMultipleTimes();
    }
  );


})();